import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import Breadcrumb from '../common/breadcrumb';
// import TeamListDataTable from './levelListDataTable';
import { getAllAffiliateLevels } from '../../reducers/adminReducers';
import Loader from '../loader/loader';
import AffiliateLevelListDataTable from './levelListDataTable';
//import { adminInstance } from '../../config/axios';
const AffiliateLevelManagement = () => {
	const dispatch = useDispatch();
	const result = useSelector((state) => state.admin);
	const { allAffiliateLevelList } = result || {};
	const [loading, setLoading] = useState(false);
	const getAllTeamdata = async () => {
		setLoading(true)
		const response = await dispatch(getAllAffiliateLevels())
		if (response?.payload) {
			setLoading(false)
		}
	}
	useEffect(() => {
		getAllTeamdata()
		// setLoading(true);
		// dispatch(getAllTeamsData());
		// setLoading(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	return (
		<>
			<Fragment>
				<Breadcrumb title="Team Management" parent="Team" />
				<Container fluid={true}>
					<div className="admin-card">
						<Card>
							<CardHeader>
								<h5>All Affiliate Levels </h5>
							</CardHeader>
							<CardBody>
								<div className="btn-popup pull-right">
									<Link to="/addAffiliateLevel" className="btn btn-secondary main-btn">
										Create Affiliate Level
									</Link>
								</div>
								<div className="clearfix"></div>
								<div
									id="batchDelete"
									className="category-table user-list order-table coupon-list-delete"
								>
									{!loading ? (
										allAffiliateLevelList.length > 0 && (
											<AffiliateLevelListDataTable
												multiSelectOption={true}
												myData={allAffiliateLevelList}
												pageSize={10}
												pagination={true}
												class="-striped -highlight"
											/>
										)
									) : (
										<Loader />
									)}
								</div>
							</CardBody>
						</Card>
					</div>
				</Container>
			</Fragment>
		</>
	);
};
export default AffiliateLevelManagement;
